import React from 'react';
import { Table } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';

export default function VarianceTable({
  projectVarianceDetails,
  varianceDetailsTotals, 
}) {
  const generateTotalsRow = () => {
    return (
      <tr>
        <td>Totals</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalMandays)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalRevenue)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalFullyLoadedCost)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalUnloadedCost)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalExternalCost)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalTotalCost)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalProfitBeforeTax)}</td>
        <td className="align-right totals-variance">{toMonetaryFormat(varianceDetailsTotals.totalProfitNetofTax)}</td>
      </tr>
    )
  }

  return (
    <Table>
      <thead>
        <tr>
          <th className="align-center remove-th-style"></th>
          <th className="align-center">Total Mandays</th>
          <th className="align-center">Total Revenue</th>
          <th className="align-center">Fully Loaded Cost</th>
          <th className="align-center">Unloaded Cost</th>
          <th className="align-center">Other Cost</th>
          <th className="align-center">Total Cost</th>
          <th className="align-center">Profit Before Tax</th>
          <th className="align-center">Profit after Tax</th>
        </tr>
      </thead>
      <tbody>
        { projectVarianceDetails }
        { generateTotalsRow() }
      </tbody>
    </Table>
  )
}

